import {
    BuildingModalIcon,
    ContractorTitle,
    EmployeesIcon,
    IconCustomAccess,
} from '../../../../components/buttons/IconButtons';
import { getStatusIdsByNames, status } from '../../../../enums/statusEnum';
import { permissionObj } from '../../../../Helpers/permission';
import { STATUS_MODEL} from "../../../../enums/statusEnum";
import { USER_TYPE_MODEL } from '../../../../enums/userTypeEnum';

/**
 * @Author: Susana García Rodriguez
 * @JobTitle: Frontend
 * @Email: sgarcia@ibl.mx
 */
export const EVENT_STATUS = {
     cancel: getStatusIdsByNames(status, [status[STATUS_MODEL.BOOKED]]),
     delete: getStatusIdsByNames(status, [status[STATUS_MODEL.CANCELED]]),
};

export const TABS_RESERVATIONS = {
    BOOKINGS: {
        INDEX: 0,
        TRANS: 'bookings',
    },
    MANAGE: {
        INDEX: 1,
        TRANS: 'manage',
    },
};

export const RESERVATIONS_SUB_VIEW_MODEL = {
    BOOKINGS: {
        REQUEST: 'REQUEST',
        STATUS: 'STATUS',
    },
    MANAGE: {},
};

export function TAB_PERMISSION_RESERVATIONS (subView){
    return {
        CREATE: {
            [TABS_RESERVATIONS.BOOKINGS.INDEX]:
                subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST
                ? permissionObj?.WEB_EVENT_CREATE
                : undefined
        },
        UPDATE: {
            [TABS_RESERVATIONS.MANAGE.INDEX]: permissionObj?.WEB_EVENT_MANAGE_UPDATE,
        },
        DELETE: {
            [TABS_RESERVATIONS.BOOKINGS.INDEX]:
                subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST
                    ? permissionObj?.WEB_EVENT_DELETE
                    : permissionObj?.WEB_EVENT_STATUS_DELETE,
        },
        CANCEL: {
            [TABS_RESERVATIONS.BOOKINGS.INDEX]:
                subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST
                ? permissionObj?.WEB_EVENT_CANCEL
                : permissionObj?.WEB_EVENT_STATUS_CANCEL,
        },
        EXPORT: {
            [TABS_RESERVATIONS.BOOKINGS.INDEX]:
                subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST
                    ? permissionObj?.WEB_EVENT_EXPORT
                    : permissionObj?.WEB_EVENT_STATUS_EXPORT,
        },
        ADVANCE_SEARCH: {
            [TABS_RESERVATIONS.BOOKINGS.INDEX]:
                subView === RESERVATIONS_SUB_VIEW_MODEL.BOOKINGS.REQUEST
                ? permissionObj?.WEB_EVENT_READ
                : permissionObj?.WEB_EVENT_STATUS_READ,
        }
    }
}
export const ATTENDANCES_TABS_MODEL = {
    EMPLOYEE: {
        id: USER_TYPE_MODEL.EMPLOYEE,
        name: 'EMPLOYEE',
        translation: 'employee',
    },
    CONTRACTOR_IN_CHARGE: {
        id: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        name: 'CONTRACTOR_IN_CHARGE',
        translation: 'contractor',
    },
    SUPPLIER_IN_CHARGE: {
        id: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        name: 'SUPPLIER_IN_CHARGE',
        translation: 'supplier',
    },
    VISITOR: {
        id: USER_TYPE_MODEL.VISITOR,
        name: 'VISITOR',
        translation: 'visitor',
    },
};

export const reservationAttendancesItems = [
    {
        id: ATTENDANCES_TABS_MODEL.EMPLOYEE.id,
        key: ATTENDANCES_TABS_MODEL.EMPLOYEE.name,
        translation: 'employees',
        icon: <EmployeesIcon className='btn-icon-svg-20px' />,
        userTypeId: USER_TYPE_MODEL.EMPLOYEE,
        total:0
    },
    {
        id: ATTENDANCES_TABS_MODEL.CONTRACTOR_IN_CHARGE.id,
        key: ATTENDANCES_TABS_MODEL.CONTRACTOR_IN_CHARGE.name,
        translation: 'contractors',
        icon: <ContractorTitle className='btn-icon-svg-20px' />,
        userTypeId: USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE,
        total:0
    },
    {
        id: ATTENDANCES_TABS_MODEL.SUPPLIER_IN_CHARGE.id,
        key: ATTENDANCES_TABS_MODEL.SUPPLIER_IN_CHARGE.name,
        translation: 'suppliers',
        icon: <IconCustomAccess className='btn-icon-svg-20px' />,
        userTypeId: USER_TYPE_MODEL.SUPPLIER_IN_CHARGE,
        total:0
    },
    {
        id: ATTENDANCES_TABS_MODEL.VISITOR.id,
        key: ATTENDANCES_TABS_MODEL.VISITOR.name,
        translation: 'visitors',
        icon: <BuildingModalIcon className='btn-icon-svg-20px' />,
        userTypeId: USER_TYPE_MODEL.VISITOR,
        total:0
    },
];

export const getReservationAttendanceByUserType = (userTypeId) => {
    return reservationAttendancesItems.find(item => item?.userTypeId === userTypeId) ?? null;
};

export const USER_TYPE_MODAL_MODEL = {
    [ATTENDANCES_TABS_MODEL.EMPLOYEE.name]: {
        titleKey: 'add_employee',
    },
    [ATTENDANCES_TABS_MODEL.CONTRACTOR_IN_CHARGE.name]: {
        titleKey: 'add_contractor',
    },
    [ATTENDANCES_TABS_MODEL.SUPPLIER_IN_CHARGE.name]: {
        titleKey: 'add_supplier',
    },
    [ATTENDANCES_TABS_MODEL.VISITOR.name]: {
        titleKey: 'add_visitor',
    },
};
